"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @enum RunType
 * Whether run is Qualitative or Quantitative (with a standard curve)
 */
var RunType;
(function (RunType) {
    RunType[RunType["Qualitative"] = 1] = "Qualitative";
    RunType[RunType["Quantitative"] = 2] = "Quantitative";
    RunType[RunType["Isothermal"] = 3] = "Isothermal";
    RunType[RunType["Melt"] = 4] = "Melt";
})(RunType = exports.RunType || (exports.RunType = {}));
